export default "__VITE_ASSET__Crql8O3X__"